import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { Autocomplete, Typography } from '@mui/material';
import { useEffect } from 'react';
import { allCountries, allIndustries, cityFilter, stateFilter } from '../../services/SignUp';
import { initStep2Data } from '../../ultis/objects/SignUp';
import { validateEmail, validatePhone, validateZipCode } from '../../ultis/regex/Regex';
import { useDispatch } from 'react-redux'
import { nextStep2 } from '../../redux/creates-action/SignUpAction';
import { useSelector } from 'react-redux';

export default function Step2() {
  const [country, setCountry] = useState([]);
  const [industry, setIndustry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [idCountry, setIdCountry] = useState('')
  const [idState, setIdState] = useState('')
  const [idCity, setIdCity] = useState('')
  const [idIndustry, setIdIndustry] = useState('');
  const data2 = useSelector(state => state.signup.data.companyInfo);
  const [values, setValues] = useState(initStep2Data('', '', '', '', '', null, null, null, null))
  const [phoneErrorText, setPhoneErrorText] = useState('')
  const [emailErrorText, setEmailErrorText] = useState('')
  const [zipCodeErrorText, setZipCodeErrorText] = useState('')
  const dispatch = useDispatch()


  useEffect(() => {
    allIndustries().then((result) => {
      setIndustry(result)
    })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  useEffect(() => {
    allCountries().then((result) => {
      setCountry(result)
    })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  useEffect(() => {
    if (idCountry !== '') {
      let data = { ...values, idState: '', idCity: '' };
      setValues(data);
      const data1 = {
        "filter": { "countryID": idCountry }
      }
      stateFilter(data1)
        .then((result) => {
          setState(result)
        }).catch((err) => {
          console.log(err)
        })
    }

  }, [idCountry])

  useEffect(() => {
    if (idState !== '') {
      let data = { ...values, idCity: '' };
      setValues(data);
      const data2 = { "filter": { "stateID": idState } }
      cityFilter(data2)
        .then((result) => {
          setCity(result)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [idState])


  useEffect(() => {
    if (
      values.brand !== ''
      && idCountry !== ''
      && idState !== ''
      && idIndustry !== ''
      && idCity !== ''
      && values.phone !== ''
      && values.zipCode !== ''
      && values.email !== ''
      && values.address !== ''
      && values.nameCountry !== null
      && values.nameState !== null
      && values.nameIndustry !== null
      && values.nameCity !== null
      && !values.isPhoneError
      && !values.isZipCodeError
      && !values.isEmailError
    ) {
      dispatch(nextStep2(values.brand, idCountry, idState, idIndustry, idCity, values.phone, values.email, values.zipCode, values.address, values.nameCountry, values.nameState, values.nameIndustry, values.nameCity))
    }
  }, [values.brand, idCountry, idState, idIndustry, idCity, values.phone, values.email, values.zipCode, values.address, values.nameCountry, values.nameState, values.nameIndustry, values.nameCity, dispatch])

  useEffect(() => {
    let data = {
      ...values,
      brand: data2.idBrand,
      nameCountry: data2.nameCountry,
      nameState: data2.nameState,
      nameIndustry: data2.nameIndustry,
      nameCity: data2.nameCity,
      phone: data2.phone,
      email: data2.email,
      zipCode: data2.zipCode,
      address: data2.address,
    };
    setValues(data);
    setIdCountry(data2.idCountry);
    setIdCity(data2.idCity);
    setIdIndustry(data2.idIndustry);
    setIdState(data2.idState);
  }, [data2.idBrand, data2.nameCountry, data2.nameState, data2.nameIndustry, data2.nameCity, data2.phone, data2.zipCode, data2.address, data2.email])

  const handleBrandChange = (event) => {
    let value = event.target.value;
    let data = { ...values, brand: value };
    setValues(data);
  }
  const handlePhoneChange = (event) => {
    let value = event.target.value;
    let data = handleValidatePhone(value);
    setValues(data);
  }

  const handleEmailChange = (event) => {
    let value = event.target.value;
    let data = handleValidateEmail(value);
    setValues(data);

  }

  const handleZipCodeChange = (event) => {
    let value = event.target.value;
    let data = handleValidateZipCode(value);
    setValues(data);

  }
  const handleAddressChange = (event) => {
    let value = event.target.value;
    let data = { ...values, address: value };
    setValues(data);
  }

  function handleValidatePhone(phone) {
    let result = validatePhone(phone);
    let data;
    if (!result) {
      data = { ...values, phone: phone, isPhoneError: true };
      setValues(data);
      setPhoneErrorText("Phone must contain 10 characters");
    } else {
      data = { ...values, phone: phone, isPhoneError: false };
      setValues(data);
      setPhoneErrorText("");
    }
    return data;
  }

  function handleValidateEmail(email) {
    let result = validateEmail(email);
    let data;
    if (!result) {
      data = { ...values, email: email, isEmailError: true };
      setValues(data);
      setEmailErrorText("Email address is invalid");
    } else {
      data = { ...values, email: email, isEmailError: false };
      setValues(data);
      setEmailErrorText("");
    }
    return data;
  }


  function handleValidateZipCode(zipCode) {
    let result = validateZipCode(zipCode);
    let data;
    if (!result) {
      data = { ...values, zipCode: zipCode, isZipCodeError: true };
      setValues(data);
      setZipCodeErrorText("ZipCode must contain 5 characters");
    } else {
      data = { ...values, zipCode: zipCode, isZipCodeError: false };
      setValues(data);
      setZipCodeErrorText("");
    }
    return data;
  }
  return (
    <React.Fragment>
      <p style={{ textAlign: 'center', margin: '24px 0 48px 0', fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif', }}>
        {/* Enter company information for sign-up */}
      </p>
      <Grid container spacing={3} sx={{ paddingRight: 2 }}>
        <Grid item xs={12} sm={4} md={6}>
          <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >Brand / Trade name</label>
          <TextField value={values.brand || ''} onChange={handleBrandChange} variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <FormControl fullWidth>
          <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >Country*</label>
            <Autocomplete
              isOptionEqualToValue={(option, value) => {
                return option.id === value?.id
              }}
              value={values.nameCountry || null}
              options={country}
              getOptionLabel={(option) => option.name}
              onChange={(e, newValue) => {
                setIdCountry(newValue === null ? '' : newValue.id)

                let data = { ...values, nameCountry: newValue, nameState: null, nameCity: null };

                setValues(data);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <FormControl sx={{}} fullWidth>
            <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >Industry</label>
            <Autocomplete
              isOptionEqualToValue={(option, value) => {
                return option.id === value?.id
              }}
              value={values.nameIndustry || null}
              options={industry}
              getOptionLabel={(option) => option.content}
              onChange={(e, newValue) => {
                setIdIndustry(newValue === null ? '' : newValue.id)
                let data = { ...values, nameIndustry: newValue };
                setValues(data);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <FormControl sx={{}} fullWidth>
            <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >State*</label>
            <Autocomplete
              isOptionEqualToValue={(option, value) => {
                return option.id === value?.id
              }}
              value={values.nameState || null}
              options={state}
              getOptionLabel={(option) => option.name}
              onChange={(e, newValue) => {
                setIdState(newValue === null ? '' : newValue.id)
                let data = { ...values, nameState: newValue, nameCity: null };
                setValues(data);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <FormControl sx={{}} fullWidth>
            <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >Phone*</label>
            <TextField value={values.phone || ''} onChange={handlePhoneChange}
              error={values.isPhoneError}
              helperText={phoneErrorText}
              variant="outlined"
              fullWidth
            ></TextField>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <FormControl sx={{}} fullWidth>
            <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >City*</label>
            <Autocomplete
              isOptionEqualToValue={(option, value) => {
                return option.id === value?.id
              }}
              value={values.nameCity || null}
              options={city}
              getOptionLabel={(option) => option.name}
              onChange={(e, newValue) => {
                setIdCity(newValue === null ? '' : newValue.id)
                let data = { ...values, nameCity: newValue };
                setValues(data);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <FormControl sx={{}} fullWidth>
            <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >Email*</label>
            <TextField value={values.email || ''} onChange={handleEmailChange}
              error={values.isEmailError}
              helperText={emailErrorText}
              variant="outlined"
              fullWidth
            ></TextField>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <FormControl sx={{}} fullWidth>
          <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >Zip code</label>
            <TextField value={values.zipCode || ''} onChange={handleZipCodeChange}
              error={values.isZipCodeError}
              helperText={zipCodeErrorText}
              variant="outlined"
              fullWidth
            ></TextField>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <FormControl sx={{}} fullWidth>
          <label style={{ fontSize: '20px', fontWeight: '500', color: '#212529', fontFamily: 'Jost, sans-serif' }} >Address*</label>
            <TextField value={values.address} onChange={handleAddressChange}
              variant="outlined"
              fullWidth
            ></TextField>
          </FormControl>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}